import * as React from 'react';

import styled from 'styled-components';

export interface TabButtonGroupProps {
    children: React.ReactNode;
}

const StyledTabButtonGroup = styled.ul`
    list-style-type: none;
    > li {
        display: inline-block;
    }
    > li:not(:first-child) > button {
        border-left: none;
    }
    > li:first-child > button {
        border-radius: 3px 0px 0px 0px;
    }
    > li:last-child > button {
        border-radius: 0px 3px 0px 0px;
    }
`;

export const TabButtonGroup = React.forwardRef<HTMLUListElement, TabButtonGroupProps>(({ children, ...props }, ref) => (
    <StyledTabButtonGroup ref={ref} {...props}>
        {children}
    </StyledTabButtonGroup>
));
TabButtonGroup.displayName = 'TabButtonGroup';
